import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { insApi, setInsToken } from "@/lib/insurance";

const Ctx = createContext(null);

export const InsurerProvider = ({ children }) => {
  const [insurer, setInsurer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    insApi.get("/auth/me").then((r) => setInsurer(r.data.insurer)).catch(() => setInsurer(null)).finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await insApi.post("/auth/login", { email, password });
    setInsToken(r.data.access_token);
    setInsurer(r.data.insurer);
  }, []);

  const logout = useCallback(async () => {
    await insApi.post("/auth/logout").catch(() => {});
    setInsToken(null);
    setInsurer(null);
  }, []);

  return <Ctx.Provider value={{ insurer, loading, login, logout }}>{children}</Ctx.Provider>;
};

export const useInsurer = () => useContext(Ctx);

export const RequireInsurer = ({ children }) => {
  const { insurer, loading } = useInsurer();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#020165]" /></div>;
  if (!insurer) return <Navigate to={`/insurer/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return children;
};
